import { ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const GuaranteeSection = () => {
  const { t } = useTranslation();

  return (
    <section id="guarantee" className="py-24 md:py-32 bg-gray-950 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-emerald-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-teal-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-sm font-semibold tracking-widest text-emerald-400 uppercase mb-4">
            {t('simonsMarketing.guarantee.badge')}
          </span>
        </div>

        <div className="relative bg-gradient-to-br from-gray-900 to-gray-900/80 rounded-3xl border border-gray-800 p-10 md:p-14">
          <div className="absolute -top-px left-12 right-12 h-px bg-gradient-to-r from-transparent via-emerald-500/50 to-transparent" />
          <div className="absolute -bottom-px left-12 right-12 h-px bg-gradient-to-r from-transparent via-emerald-500/20 to-transparent" />

          <div className="flex flex-col items-center text-center">
            <div className="w-20 h-20 rounded-2xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center mb-8">
              <ShieldCheck className="w-10 h-10 text-emerald-400" />
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
              {t('simonsMarketing.guarantee.title')}
            </h2>

            <div className="w-16 h-1 bg-gradient-to-r from-emerald-500 to-teal-400 rounded-full mb-8" />

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-2xl">
              {t('simonsMarketing.guarantee.description')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuaranteeSection;
